module.exports = __webpack_public_path__ + "img/Icon_DingSlotsDing.542aec24.png";